export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Voice training, pitch accuracy, and vocal range development.</li>
                                <li>Styles including pop, jazz, R&B, soul, and gospel.</li>
                                <li>Harmony singing, improvisation, and vocal runs.</li>
                                <li>Studio mic techniques and stage presence.</li>
                                <li>Repertoire building tailored to student goals.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Beginners passionate about contemporary music.</li>
                                <li>Aspiring vocalists for bands, concerts, and competitions.</li>
                                <li>Singers preparing for graded exams (Trinity/Rock School).</li>
                                <li>Students aiming for a professional career in Western music.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Confident performance in contemporary genres.</li>
                                <li>Versatility across multiple singing styles.</li>
                                <li>Recording-ready voice for studios.</li>
                                <li>Strong stage presence and individuality as a vocalist.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 